<template>
  <div>
    <div class="ui-snackbar" :class="{ 'has-action': hasAction }">
      <div class="ui-snackbar-text">
        {{ message }}
      </div>
      <div v-if="hasAction" class="ui-snackbar-action">
        <router-link v-if="action.type == 'link'" :to="action.to">
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
    showButton: Boolean,
    duration: {
      type: [String, Number],
      default: 5000,
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  computed: {
    hasAction() {
      return Boolean(this.action && this.action.message);
    },
  },
  mounted() {},
  methods: {},
};
</script>
